import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { Inspection } from '../../../../../src/app/shared/models';

@Component({
    selector: 'inspection-status',
    templateUrl: './status.component.html',
    standalone: false
})
export class InspectionStatusComponent implements OnInit {
  @Input() public statusList: any[];
  @Input() public inspection: Inspection;
  @Output() public toggleSaveStatus: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();

  statusForm: UntypedFormGroup;

  ngOnInit(): void {
    this.initForm();
  }

  public updateStatus(model: any) {
    this.inspection.status = model.status;
    this.toggleSaveStatus.emit(this.inspection);
  }

  public cancel() {
    this.toggleCancel.emit();
  }

  initForm() {
    this.statusForm = new UntypedFormGroup({
      status: new UntypedFormControl(this.inspection.status, Validators.required)
    });
  }
}
